var Dlrt;
(function (Dlrt) {
    class TimelineBase {
        constructor(view, options = null) {
            this.view = view;
            this.resultTemplate = Handlebars.compile($(options.templateSelector).html());
            this.resultsContainer = $(options.resultsContainerSelector);
            this.options = $.extend({}, TimelineBase.DefaultOptions, options);
            this.initSpinner();
        }
        get View() {
            return this.view;
        }
        find(selector) {
            return this.view.find(selector);
        }
        get ResultsContainer() {
            return this.resultsContainer;
        }
        get QueryParameters() {
            return this.options.queryParameters;
        }
        get Options() {
            return this.options;
        }
        initSpinner() {
            const spinnerTemplate = '<div class="loading-spinner"><i class="fa fa-spinner fa-spin fa-fw" ></i></div>';
            this.spinnerTemplate = Handlebars.compile(spinnerTemplate);
        }
        getContent() {
            if (this.options.beforeProcessing)
                this.options.beforeProcessing();
            this.resultsContainer.empty();
            if (this.spinnerTemplate) {
                this.resultsContainer.append(this.spinnerTemplate(null));
            }
            $.ajax({
                type: 'GET',
                cache: false,
                url: this.options.queryUrl,
                data: this.options.queryParameters,
                traditional: true,
                beforeSend: () => {
                    this.resultsContainer.empty();
                    if (this.spinnerTemplate) {
                        this.resultsContainer.append(this.spinnerTemplate(null));
                    }
                },
                success: (data) => {
                    this.resultsContainer.empty();
                    if (data.totalCount > 0) {
                        const items = data.items;
                        for (const i of items) {
                            this.resultsContainer.append(this.resultTemplate(i));
                        }
                    }
                    else {
                        this.resultsContainer.append("<p class='no-data-found'>" + this.options.noDataText + "</p>");
                    }
                    if (this.options.afterProcessing)
                        this.options.afterProcessing();
                },
                error: () => {
                    this.resultsContainer.html("<p>" + this.options.errorText + "</p>");
                }
            });
        }
    }
    TimelineBase.DefaultOptions = {
        noDataText: "No entry found.",
        errorText: "An unexpected error occured during Timeline loading.",
    };
    Dlrt.TimelineBase = TimelineBase;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=timelineBase.js.map
